import axios from 'axios';

export interface ProductAnalyticsEventIdentity {
	category: string;
	feature: string;
	subfeature: string;
	action: string;
}

export interface AnalyticsEventRequest extends ProductAnalyticsEventIdentity {
	area?: string;
	section?: string;
	component?: string;
}

export const createAnalyticsEvent = async (data: AnalyticsEventRequest): Promise<void> => {
	await axios.post('/analytics/events', data);
};
